import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { formatCurrency } from '@telialt/utils/src/helpers';

import { GIFT_SELECTION_TEST_ID } from '../../constants';
import { PriceElement } from './PriceTag.styles';

const PriceTagAccessible = withA11yVisuallyHidden(PriceElement);

type PriceProps = { children: string | number };

export const Price: FC<PriceProps> = ({ children: price }) => {
    const priceFormatted = typeof price === 'number' ? formatCurrency(price) : price;

    return (
        <PriceTagAccessible accessible={priceFormatted} data-test={GIFT_SELECTION_TEST_ID.PRICE}>
            {priceFormatted}
        </PriceTagAccessible>
    );
};
